module.exports = __webpack_public_path__ + "img/money.51912913.png";